import { useEffect, useState } from 'react';
import { Table, Input, Button, Popconfirm } from 'antd';
import { GetEmpresas, FormEmpresa, DeleteEmpresa } from '@actions/empresasActions';
import EmpresaLegalizacaoForm from './EmpresaLegalizacaoForm';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { getColumnSearchProps, sortAlpha, filterobject } from '@utils/filterandsort';
import { SetPageHeader } from '@actions/userActions';
import { Permission } from '@hooks//usePermissions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { Empresalegalizacao } from '@models/EmpresaLegalizacao';

function EmpresasLegalizacaoView() {
  const dispatch = useAppDispatch();
  const empresas = useAppSelector((state) => state.empresas);
  const [filter, setFilter] = useState('');
  useEffect(() => {
    dispatch(GetEmpresas());
    dispatch(
      SetPageHeader({
        title: 'Cadastros',
        backbutton: true,
        extras: [
          <Permission key="1" permission="empresa.add">
            <Button onClick={() => dispatch(FormEmpresa(null, true))} type="primary">
              Nova Empresa
            </Button>
          </Permission>,
        ],
        subtitle: 'Empresas',
        menu: 'empresas',
      })
    );
  }, []);

  return (
    <div>
      <EmpresaLegalizacaoForm />
      <div style={{ textAlign: 'right' }}>
        <Input style={{ width: 200 }} onChange={(e) => setFilter(e.target.value)} placeholder="Buscar" allowClear />
      </div>
      <Table
        size="small"
        rowKey="id"
        loading={empresas.loadingempresas}
        dataSource={filterobject(empresas.empresas, filter)}
        scroll={{ y: 'calc(100vh - 300px)', x: 1024 }}
        pagination={{
          position: ['bottomRight'],
          size: 'small',
          showSizeChanger: true,
          pageSizeOptions: [10, 25, 50, 100],
          showTotal: (total, range) => `Mostrando ${range[0]} a ${range[1]} de ${total} itens`,
        }}
      >
        <Table.Column
          width={80}
          fixed="left"
          render={(_, row: Empresalegalizacao) => (
            <div>
              <Permission permission="empresa.update">
                <Button icon={<EditOutlined />} onClick={() => dispatch(FormEmpresa(row.id, true))} size="small" />
              </Permission>
              <Permission permission="empresa.delete">
                <Popconfirm title="Está certo disso?" onConfirm={() => dispatch(DeleteEmpresa(row.id))}>
                  <Button icon={<DeleteOutlined />} size="small" />
                </Popconfirm>
              </Permission>
            </div>
          )}
        />
        <Table.Column
          title="Nome"
          dataIndex="nome"
          sorter={(a, b) => sortAlpha(a.nome, b.nome)}
          {...getColumnSearchProps('nome', 'string', 'Nome')}
        />
        <Table.Column title="CNPJ" dataIndex="cnpj" {...getColumnSearchProps('cnpj', 'string', 'CNPJ')} />
        <Table.Column title="Contato" dataIndex="contato" {...getColumnSearchProps('contato', 'string', 'Contato')} />
      </Table>
    </div>
  );
}
export default EmpresasLegalizacaoView;
